import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/** Old Finance menu URL → Audit evidence */
export const LegacyFinancePageRedirect: React.FC = () => (
  <Navigate to="/admin/audit-evidence" replace />
);

/** Legacy list URL → Channel Partners hub */
export const LegacyDisbursementClientsListRedirect: React.FC = () => (
  <Navigate to="/admin/channel-partners" replace />
);

/** Legacy detail URL → Channel Partner command centre */
export const LegacyDisbursementClientDetailRedirect: React.FC = () => {
  const { clientId } = useParams<{ clientId: string }>();
  return <Navigate to={`/admin/channel-partners/${clientId}`} replace />;
};

/** Pre-Phase-A mirror paths (no /portal prefix) → portal mirror */
export const LegacyCpMirrorPathRedirect: React.FC<{ tail: string }> = ({ tail }) => {
  const { clientId } = useParams<{ clientId: string }>();
  const suffix = tail.startsWith('/') ? tail : `/${tail}`;
  return <Navigate to={`/admin/channel-partners/${clientId}/portal${suffix}`} replace />;
};

/** Pre-Phase-A mirror run detail */
export const LegacyCpMirrorRunDetailRedirect: React.FC = () => {
  const { clientId, id } = useParams<{ clientId: string; id: string }>();
  return <Navigate to={`/admin/channel-partners/${clientId}/portal/runs/${id}`} replace />;
};
